import axios from 'axios';
import {env} from '../env';


export const getConfig = () => {
 return get('/config');
}
export const postConfig = (data) => {
  return post('/config',data);
}
export const getDefaultConfig = () => {
  return get('/config/default');
}
const post = async (path,data) => {
  return fetch(env.REACT_APP_RAG_URL + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  }).then(response => {
    if (!response.ok) {
      return response.json().then(err => { throw err; });
    }
    return response.json();
  });
}
const get = async (path) => {
  return axios.get(env.REACT_APP_RAG_URL + path);
}
export default {
  getConfig,
  postConfig
}; 